module.exports = __webpack_public_path__ + "609c8a76c3ab9091019023d65b3a0044.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/accessibility/oc.svg
// module id = OXK2
// module chunks = 0